'use strict';

var joinSchemeLogin = require('./joinSchemeLogin');

$(document).on('click', '.download-receipt', function (e) {
    e.preventDefault();
    var $this = $(this);

    // Identifiers go in the POST body so they never appear in the URL
    fetch($this.data('url'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: $.param({
            docNo: $this.data('doc-no'),
            passbookNo: $this.data('passbook-no')
        })
    })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            if (joinSchemeLogin.handleAccessDenied(data)) {
                return;
            }
            if (!data || !data.success || !data.pdf) {
                $('body').trigger('failureToast', 'Unable to download the receipt.');
                return;
            }
            var binary = atob(data.pdf);
            var len = binary.length;
            var bytes = new Uint8Array(len);

            for (var i = 0; i < len; i += 1) {
                bytes[i] = binary.charCodeAt(i);
            }

            var blob = new Blob([bytes], { type: 'application/pdf' });
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'Receipt.pdf';
            a.click();
        })
        .catch(function () {
            $('body').trigger('failureToast', 'Unable to download the receipt.');
        });
});

$(document).on('click', '.account-ledger-view', function (e) {
    e.preventDefault();
    var $this = $(this);
    $.spinner().start();
    $.ajax({
        url: $this.data('url-action'),
        type: 'POST',
        data: {
            passbookNo: $this.data('passbook-no')
        },
        success: function (response) {
            $.spinner().stop();
            if (typeof response !== 'string' || response.indexOf('ledgerModal') === -1) {
                // Session expired: log in again and come back to the saving schemes page
                window.redirectToSavingSchemePage = true;
                $('#loginPopupModal').modal('show');
                return;
            }
            $('#ledgerModal').remove();
            $('body').append(response);
            $('#ledgerModal').modal('show');
        },
        error: function (xhr) {
            $.spinner().stop();
            joinSchemeLogin.handleAccessDenied(xhr);
        }
    });
});
$(document).on('click', '.download-ledger', function () {
    var $clone = $('#ledgerModal .modal-content').clone(true, true);

    $clone.find('.pdf-remove').remove();
    $clone.find('.close').remove();

    $clone.css({
        display: 'block',
        maxHeight: 'none',
        overflow: 'visible',
        width: '1160px'
    });

    $clone.find('.modal-body').css({
        display: 'block',
        flex: 'none',
        overflow: 'visible',
        minHeight: '0'
    });

    $clone.find('.ledger-table-wrapper').css({
        overflow: 'visible',
        maxHeight: 'none'
    });

    $clone.find('thead').css('position', 'static');
    $clone.find('thead th').css('box-shadow', 'none');
    $clone.find('tfoot td').css('position', 'static');

    var $loadingOverlay = $(
        '<div class="pdf-loading-overlay">'
            + '<div class="pdf-loading-box"><i class="fa fa-spinner fa-spin"></i> Generating PDF...</div>'
            + '</div>'
    );
    $('body').append($loadingOverlay);

    var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

    var $captureContainer = $('<div class="ledger-modal pdf-capture-container">')
        .css({
            position: 'absolute',
            top: (docHeight + 100) + 'px',
            left: 0,
            width: '1200px',
            background: '#fff',
            padding: '20px'
        })
        .append($clone);

    $('body').append($captureContainer);

    /**
     * Removes the temporary capture container and loading overlay
     * created for the PDF export.
     */
    function cleanup() {
        $captureContainer.remove();
        $loadingOverlay.remove();
    }

    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            window.html2canvas($captureContainer.get(0), {
                scale: 2,
                useCORS: true
            }).then(function (canvas) {
                var imgData = canvas.toDataURL('image/jpeg', 1.0);

                var JsPDF = window.jspdf.jsPDF;
                var pdf = new JsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });

                var pageWidth = pdf.internal.pageSize.getWidth();
                var pageHeight = pdf.internal.pageSize.getHeight();
                var margin = 10;
                var usableWidth = pageWidth - margin * 2;
                var usableHeight = pageHeight - margin * 2;

                var imgWidth = usableWidth;
                var imgHeight = (canvas.height * imgWidth) / canvas.width;

                var heightLeft = imgHeight;
                var position = margin;

                pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
                heightLeft -= usableHeight;

                // multi-page support if the ledger is long
                while (heightLeft > 0) {
                    position = heightLeft - imgHeight + margin;
                    pdf.addPage();
                    pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
                    heightLeft -= usableHeight;
                }

                pdf.save('Saving-Scheme-Ledger.pdf');
                cleanup();
            }).catch(function (err) {
                // eslint-disable-next-line no-console
                console.error('PDF generation failed:', err);
                cleanup();
            });
        });
    });
});
